/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = state => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Set the collateral payload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const GET_COLLATERAL_SUCCESS = (state, payload) => {
    state.collateral = payload
}

/**
 * Set the collateral error state
 *
 * @param  {Object} state
 * @return {Void}
 */
const GET_COLLATERAL_FAILURE = state => {
    state.error = true
}

/**
 * New collateral failed action
 *
 * @param  {Object} state
 * @param  {Object} response
 * @return {Void}
 */
const SAVE_COLLATERAL_FAILURE = (state, errors) => {
    state.errors = errors
}

const TOGGLE_CREATE_MODAL = state => {
    state.showFormModal = !state.showFormModal
}

/**
 * Remove collateral from state
 *
 * @param  {Object} state
 * @param  {Number} id
 * @return {Void}
 */
const REMOVE_COLLATERAL_SUCCESS = (state, id) => {
    state.collateral = state.collateral.filter(i => i.id !== id)
}

/**
 * Remove an error key
 *
 * @param  {Object} state
 * @param  {String} key
 * @return {Void}
 */
const CLEAR_ERRORS = (state, key) => {
    Vue.delete(state.errors, key)
}

const RESET_FORM = state => {
    state.errors = []
    state.editing = null
}

const SET_EDITABLE_COLLATERAL = (state, id) => {
    state.editing = state.collateral.find(i => i.id === id)
    state.showFormModal = true
}

const SET_LOADING = state => {
    state.loading = true
}

const RESET_LOADING = state => {
    state.loading = false
}

const TOGGLE_UPLOAD_MODAL = state => {
    state.showUploadModal = !state.showUploadModal
}

export default {
    RESET_FORM,
    RESET_STATE,
    SET_LOADING,
    CLEAR_ERRORS,
    RESET_LOADING,
    TOGGLE_UPLOAD_MODAL,
    TOGGLE_CREATE_MODAL,
    GET_COLLATERAL_SUCCESS,
    GET_COLLATERAL_FAILURE,
    SAVE_COLLATERAL_FAILURE,
    SET_EDITABLE_COLLATERAL,
    REMOVE_COLLATERAL_SUCCESS
}



// WEBPACK FOOTER //
// ./src/state/modules/debt-servicing/mutations.js